"use client";

import { VideoCarousel } from "@bfl-ui-toolkit/video-carousel";
import { IWatchOurVideos } from "../../interfaces/AMCChartData.interface";
import { dataLayer, CombinedClevertapProps } from "@repo/analytics/data-layer-utils";
import { selectLoginStatus, useAppSelector } from "@repo/global-store";

const AMCVideoCarousel = ({ videoCarouselData }: { videoCarouselData: IWatchOurVideos }) => {
  const loginStatus = useAppSelector(selectLoginStatus);

  const videos = Object.values(videoCarouselData?.videoData?.[0] ?? {}).map((item, index) => {
    const kpointId = item?.gccid?.match(/(gcc-[^.]+)/)?.[1] ?? "";

    return {
      id: item?.packageid ?? `video-${index}`,
      displayName: item?.videodescription,
      thumbnailUrl: item?.gccid,
      kpointId,
    };
  });

  const trackVideoCarouselClickEvent = () => {
    const payload = {
      component: "amc_video_carousel",
      element: "video_carousel_click",
      event: "click",
      event_type: "product_card_product_video_carousel_video_click",
      destination_url: "NA",
      section_title: videoCarouselData?.videotitle,
      cta_text: "Video Carousel",
      product_name: "bajaj_mutual_fund",
      category_name: "mutual_fund",
      page_type: "pdp",
      component_position: "",
      component_id: "amc_video_carousel",
    };

    dataLayer(loginStatus, payload, payload as unknown as CombinedClevertapProps);
  };

  const trackEvent = (payload?: { clickType?: string }) => {
    switch (payload?.clickType) {
      case "product_card_product_video_carousel_video_click":
        trackVideoCarouselClickEvent();
        break;

      default:
        break;
    }
  };

  return (
    <div
      className="mb-3 md:px-5 md:py-2"
      data-cmp="AMCVideoCarousel"
      data-cmp-type="react"
      data-cmp-title={videoCarouselData?.videotitle || "Video Carousel"}
    >
      <VideoCarousel
        title={videoCarouselData?.videotitle}
        videos={videos}
        trackEvent={trackEvent}
      />
    </div>
  );
};

export default AMCVideoCarousel;
